module.exports = __webpack_public_path__ + "img/icon-reward-rules.436d8b0b.png";